import { ContentRequest, ContentRequestState } from '@amzn/awscat-pattern-library-service-model';
import React from 'react';
import { IMplServiceClient } from '../../api/IMplServiceClient';
import { MplServiceClientFactory } from '../../api/MplServiceClientFactory';
import constants from '../../common/constants';
import FlashbarMessageBroker from '../../common/FlashbarMessageBroker';
import ModalDialogButtonV3 from '../common/ModalDialogButtonV3';

interface Props {
  contentSuggestion: ContentRequest;
}

class DeleteContentSuggestionButton extends React.Component<Props> {
  private mplServiceClient: IMplServiceClient = MplServiceClientFactory.create();
  private flashbarMessageBroker: FlashbarMessageBroker = FlashbarMessageBroker.create();

  public render() {
    const { state } = this.props.contentSuggestion;

    if (![ContentRequestState.REQUESTED, ContentRequestState.REJECTED].includes(state)) {
      return null;
    }

    return (
      <ModalDialogButtonV3
        variant="icon"
        iconUrl={'/images/icon-delete.svg'}
        iconAlign="right"
        header={constants.DELETE_CONTENT_HEADER_TEXT}
        text={constants.DELETE_CONTENT_SUGGESTION_MODAL_TEXT}
        submitButtonText={constants.DELETE_CONTENT_BUTTON_TEXT}
        onSubmit={this.deleteContentSuggestion}
      />
    );
  }

  private deleteContentSuggestion = async () => {
    const { contentSuggestion } = this.props;

    await this.mplServiceClient.deleteContentRequest(contentSuggestion.requestId);

    this.flashbarMessageBroker.pushSuccessMessage(
      'Content suggestion deleted. Please refresh the table.',
    );
  };
}

export default DeleteContentSuggestionButton;
